import { render, staticRenderFns } from "./Rest.vue?vue&type=template&id=3516cfae&"
import script from "./Rest.vue?vue&type=script&lang=js&"
export * from "./Rest.vue?vue&type=script&lang=js&"
import style0 from "./Rest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports